export default (function (accessToken, apply) {
    if (apply === void 0) { apply = true; }
    if (!apply)
        return {};
    return {
        context: {
            headers: {
                Authorization: accessToken
            }
        }
    };
});
